<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link">
                  {{cityname[citrs].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in cityname"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="https://zf.sqifu.com">政府机构</a>
            </li>
            <li v-if="citr ==0 ">
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
            <li v-if="citr == 1 ">
              <i class="el-icon-phone"></i>0934--8612991
            </li>
          </ul>
        </div>
      </div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img" @click="logo()">
            <img src="../../assets/img/top_logo.png" alt />
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="top_botm">
        <div class="top-botm_cent">
          <ul class="top-botm_ul">
            <li style="width: 150px; text-align: left; margin-left:0;" class="lii">
              <a href="#" style="font-size:16px">服务类目</a>
            </li>
            <router-link
              :to="{name:'login'}"
              style="margin-left: 58px;"
              tag="li"
              v-if="err === 20001"
            >
              <a href="#">首页</a>
            </router-link>
            <router-link
              :to="{name:'home'}"
              style="margin-left: 58px;"
              tag="li"
              v-if="err != 20001"
            >
              <a href="#">首页</a>
            </router-link>
            <router-link style="margin-left: 58px;" :to="{name:'zhengwu'}" tag="li">
              <a href="#">政务政策</a>
            </router-link>
            <li>
              <a href="#">商机人脉</a>
            </li>
            <li class="hover_li">
              <a href="#">解决方案</a>
              <div class="top_show">
                <div class="top_show_1">
                  <ul>
                    <li tag="li">
                      <p>
                        <a href="#">商会行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">赋能商会信息化建设</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">企服行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">助力企业决胜互联网+时代</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">政企行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">民营企业服务平台建设运营</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">一站式定制开发解决方案</a>
                      </p>
                      <p>
                        <a href="#">应用类软件定制化开发服务</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <router-link :to="{name:'guanyu'}" tag="li">
              <a href="#">关于商企服</a>
            </router-link>
            <!-- <router-link :to="{name:'hezuo'}" tag="li">
              <a href="#">合作代理</a>
            </router-link> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="bread_1">
        <el-breadcrumb-item :to="{ path: '/login' }" v-if="err === 20001">
          <!-- <img src="../../assets/img/fuwu/nav_btn_home.png" alt=""> -->
          <span style="margin-left: 20px;">商企服首页</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }" v-if="err != 20001">
          <!-- <img src="../../assets/img/fuwu/nav_btn_home.png" alt=""> -->
          <span style="margin-left: 20px;">商企服首页</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span>{{this.name}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="content_1">
        <div class="content_2">
          <div class="content_2top">
            <ul class="content_2top_ul">
              <p style="float:left" class="content_2top_p">服务分类</p>
              <li @click="itemone()">
                <a href="#">全部</a>
              </li>
              <li v-for="(item,index) in lists1" :key="index" @click="itemtwo(item.id)">
                <a href="#">{{item.category_name}}</a>
              </li>
            </ul>
            <!-- <ul class="content_2top_ul" style="border:0">
              <p style="float:left" class="content_2top_p">服务标签</p>
              <li>
                <a href="#">全部</a>
              </li>
              <li>
                <a href="#">模板建站</a>
              </li>
              <li>
                <a href="#">企业网站</a>
              </li>
              <li>
                <a href="#">电商网站</a>
              </li>
              <li>
                <a href="#">二次开发</a>
              </li>
              <li>
                <a href="#">大数据服务</a>
              </li>
              <li>
                <a href="#">后端开发</a>
              </li>
              <li>
                <a href="#">PC+手机站</a>
              </li>
              <li>
                <a href="#">网站维护</a>
              </li>
            </ul>-->
          </div>
        </div>
      </div>
      <div class="content_two">
        <ul>
          <li v-for="(item,index) in lists" :key="index" @click="idem(item.id)">
            <div class="imgg">
              <img :src="'https://ctapi.sqifu.com/image/'+item.header_img" alt />
            </div>
            <p style="color:#F7681E;font-size:20px;">￥{{item.price}}</p>
            <p class="content_two_p2">
              <a href="#" @click="fuclick(item.id)">{{item.service_name}}</a>
            </p>
            <p style="color:#666666;font-size:14px;">{{item.providers_name}}</p>
            <p style="font-size:12px;color:#666666;">
              <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
              <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
              <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
              <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
              <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
              5.0
            </p>
          </li>
        </ul>
      </div>
      <div class="content_three">
        <div class="content_three_1">
          <el-pagination
            class="fenye"
            background
            @current-change="handleCurrentChange"
            :current-page="current_page"
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="floor">
      <div class="floor_china">
        <div class="floor_china_1">
          <ul style="margin-left: 0;">
            <p>关于我们</p>
            <li style="margin-top: 24px;">
              <a href="#" @click="about()">关于商企服</a>
            </li>
            <li>
              <a href="#" @click="about()">奖项荣誉</a>
            </li>
            <li>
              <a href="#" @click="about()">商企资讯</a>
            </li>
            <li>
              <a href="#" @click="about()">联系我们</a>
            </li>
          </ul>
          <ul>
            <p>我要入驻</p>
            <li style="margin-top: 24px;" @click="fuwushang()">
              <a href="#">服务商入驻</a>
            </li>
            <li>


              
              <a href="#" @click="shanghui()">商会入驻</a>
            </li>
            <!-- <li @click="hezuo()">
              <a href="#">代理商合作</a>
            </li> -->
          </ul>
          <ul>
            <p>服务&支持</p>
            <li style="margin-top: 24px;">
              <a href="https://www.aliyun.com/?utm_content=se_1002986587">阿里云</a>
            </li>
            <li>
              <a href="https://cloud.tencent.com/?fromSource=gwzcw.330897.330897.330897">腾讯云</a>
            </li>
            <li>
              <a href="https://c.qq.com/">腾讯创业服务平台</a>
            </li>
          </ul>
        </div>
        <div class="floor_china_2">
          <img src="../../assets/img/bottom_logo_blue.png" alt />
          <span>/ 基于商会的一站式企业服务平台</span>
          <p>免费为商业服务类公司提供线上智能化CRM系统及B2B商城，以其强大的商会会员流量体系帮助企业服务类公司进行拓客。</p>
        </div>
      </div>
    </div>
    <div class="floor_1">
      <p>
        <span><a href="http://beian.miit.gov.cn"  target="_blank" style='color:#85919a'>津ICP备19005305号</a></span>
        <img src="../../assets/img/bottom_icon_filing.png" alt style="margin-top:5px;" />
        <span><a href="http://www.beian.gov.cn"  target="_blank" style='color:#85919a'>公安网备案12010302001745号</a></span>
      </p>
    </div>
    <!--  -->
    <div class="dingbu">
      <div class="dingbu_img">
        <img
          src="../../assets/img/hover_btn_xcx.png"
          alt
          class="dingbu_img_1"
          v-show="seen&&index==current"
        />
        <img
          src="../../assets/img/hover_btn_app.png"
          alt
          class="dingbu_img_2"
          v-show="seen1&&index==current1"
        />
        <img
          src="../../assets/img/hover_btn_gzh.png"
          alt
          class="dingbu_img_3"
          v-show="seen2&&index==current2"
        />
        <img
          src="../../assets/img/hover_btn_tel.png"
          alt
          class="dingbu_img_4"
          v-show="seen3&&index==current3"
        />
      </div>
      <ol class="dingbu_1">
        <li @mouseenter="lever(index)" @mouseleave="leve()">
          <a href="#">小程序</a>
        </li>
        <li @mouseenter="lever1(index)" @mouseleave="leve1()">
          <a href="#">下载APP</a>
        </li>
        <li @mouseenter="lever2(index)" @mouseleave="leve2()">
          <a href="#">公众号</a>
        </li>
        <li style="border:0;" class="ol_li" @click="toTop">
          <img src="../../assets/img/hover_btn_top_nor.png" alt class="img_block" />
          <img src="../../assets/img/hover_btn_top_pre(1).png" alt class="img_none" />
        </li>
        <li class="dingbu_2" @mouseenter="lever3(index)" @mouseleave="leve3()">
          <!-- <img src="../assets/img/hover_btn_top_pre.png" alt=""> -->
          <img src="../../assets/img/hover_btn_kf_nor.png" alt class="img_block" />
          <img src="../../assets/img/hover_btn_top_pre.png" alt class="img_none" />
          <p href="#">客服</p>
        </li>
      </ol>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div>-->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
import storage from "@/model/storage.js";
export default {
  data() {
    return {
      current: 0,
      seen: 0,
      current1: 0,
      seen1: 0,
      current2: 0,
      seen2: 0,
      current3: 0,
      seen3: 0,
      index: 0,
      lists: [],
      total: 0,
      to: 0,
      current_page: 1,
      lists1: [],
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      cityname: [],
      citr: 0,
      err: 0
    };
  },
  methods: {
    //划过
    munn() {
      this.num1 = 1;
    },
    munn1() {
      this.num1 = 2;
    },
    //划过
    lever() {
      this.seen = true;
      this.current = false;
    },
    leve() {
      this.seen = true;
      this.current = null;
    },
    lever1() {
      this.seen1 = true;
      this.current1 = false;
    },
    leve1() {
      this.seen1 = true;
      this.current1 = null;
    },
    lever2() {
      this.seen2 = true;
      this.current2 = false;
    },
    leve2() {
      this.seen2 = true;
      this.current2 = null;
    },
    lever3() {
      this.seen3 = true;
      this.current3 = false;
    },
    leve3() {
      this.seen3 = true;
      this.current3 = null;
    },
    logo() {
      this.$router.push({
        name: "home"
      });
    },
    //服务详情
    idem(id) {
      this.$router.push({
        name: "fuwuxiang",
        query: {
          id: id
        }
      });
    },
    //服务分类
    itemtwo(id, page) {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getServiceGoodsByCategoryId",
        {
          city_id: this.id,
          category_id: id,
          page: 1
        },
        "post"
      ).then(res => {
        this.lists = res.data.data.data;
      });
    },
    //全部
    itemone() {
      var query = this.$route.query.id;
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getServiceGoodsByCategoryId",
        { category_id: query, city_id: this.id, page: 1 },
        "post"
      ).then(res => {
        this.lists = res.data.data.data;
      });
    },
    //服务分类
    getCategoryByPid(query) {
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getCategoryByPid",
        { category_id: query },
        "post"
      ).then(res => {
        this.lists1 = res.data.data;
      });
    },
    handleCurrentChange(current_page, query) {
      this.current_page = current_page;
      if (query != null) {
        this.getServicequery(current_page);
      } else {
        this.getService(current_page);
      }
    },
    Provider(provider_id) {
      this.id = localStorage.getItem("city_id");
      if (provider_id != undefined) {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/getServiceGoodsByProviderId",
          {
            provider_id: provider_id,
            city_id: this.id,
            page: 1
          },
          "post"
        ).then(res => {
          this.lists = res.data.data.data;
        });
      }
    },
    getServicequery(query, page) {
      this.id = localStorage.getItem("city_id");
      if (query != undefined) {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/getServiceGoodsByCategoryId",
          { category_id: query, city_id: this.id, page: page },
          "post"
        ).then(res => {
          this.lists = res.data.data.data;
          this.total = res.data.data.total;
        });
      }
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {});
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          this.login_login = res.data;
          if (res.data.errcode === 200) {
            this.$store.commit("setToken", res.data.data.token);
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {});
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    getRegion() {
      getRegionList({}).then(res => {
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checkislogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        this.err = res.data.errcode;
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    fuclick(id) {
      this.$router.push({
        name: "fuwuxiang",
        query: { id: id }
      });
    },
    getService(page, query, provider_id) {
      this.id = localStorage.getItem("city_id");
      if (query === undefined || provider_id === undefined) {
        this.$http(
          "https://ctapi.sqifu.com/api/v1/getServiceGoodsByCity",
          {
            city_id: this.id,
            page: page
          },
          "post"
        ).then(res => {
          this.lists = res.data.data.data;
          this.total = res.data.data.total;
        });
      }
    },
    getcityid() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.cityname = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      // this.$router.push({
      //   name:'kong'
      // });
      this.$router.go(-1);
    }
  },
  created() {
    var query = this.$route.query.id;
    this.name = this.$route.query.category_name;
    var provider_id = this.$route.query.provider_id;
    this.getCategoryByPid(query);
    this.Provider(provider_id);
    this.getServicequery(query);
    this.getService(query, provider_id);
    this.getRegion(); //城市
    this.getcityid();
    this.citrs = localStorage.getItem("citr");
    this.checlogin();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.dingbu_2 img {
  width: 24px;
  height: 24px;
  margin: 0px 0 0 3px;
}

.lii {
  height: 40px;
  background: #0812d8;
}

.floor {
  width: 100%;
  background: #2d3236;
}

.floor_china {
  width: 1200px;
  height: 224px;
  margin: 0 auto;
  overflow: hidden;
}

.floor_china_1 {
  width: 750px;
  height: 104px;
  border-right: 1px solid #85919a;
  margin: 60px 0 0 0;
  float: left;
}

.floor_china_1 ul {
  float: left;
  margin-left: 180px;
}

.floor_china_1 li {
  color: #85919a;
  font-size: 14px;
}

.floor_china_1 p {
  color: #fff;
}

.floor_china_2 {
  width: 365px;
  height: 104px;
  float: right;
  margin: 60px 0 0 0;
}

.floor_china_2 span {
  color: #ffffff;
  font-size: 14px;
}

.floor_china_2 p {
  color: #85919a;
  font-size: 14px;
  margin-top: 21px;
}

.top_hover {
  width: 150px;
  height: 426px;
  background: #323445;
  position: absolute;
}

.floor_1 {
  width: 100%;
  height: 56px;
  background: #efefef;
}

.floor_1 p {
  text-align: center;
  line-height: 56px;
  color: #85919a;
  font-size: 14px;
}

.top_hover p {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #414354;
}

.top_hover p a {
  text-align: left;
  margin: 0 0 0 28px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
}

.top_hover p i {
  width: 6.3px;
  height: 12px;
  float: right;
  padding: 23px 20px;
  color: #fff;
}

.top_hover_block {
  width: 522px;
  height: 499px;
  background: #999;
  position: absolute;
  top: 164px;
  left: 50%;
  margin-left: -450px;
}
.top_hover p:hover {
  background: #fff;
  color: #007bff;
}

.top_hover p:hover i {
  color: #007bff;
}

.top_hover p:hover a {
  color: #007bff;
}

.top_hover p:hover .top_hover_block {
  display: block;
}

.lii a {
  margin: 0 0 0 30px;
  color: #fff;
  font-size: 14px;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  background: #f4f5f9;
  min-width: 1200px;
}

.top {
  width: 100%;
  background: #f5f6fa;
  position: fixed;
  z-index: 1;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.top_cent_p {
  font-size: 14px;
  color: #007bff;
  line-height: 40px;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  float: right;
  display: flex;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}

.top_china {
  width: 100%;
  overflow: hidden;
  margin-top:40px; 
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 104px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_botm {
  width: 100%;
  height: 40px;
  background: #005aff;
}

.top-botm_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}
.top-botm_ul li {
  width: 100px;
  height: 40px;
  float: left;
  margin-left: 40px;
  line-height: 40px;
  text-align: center;
}

.top-botm_cent ul li a {
  color: #fff;
  font-size: 16px;
}

.top-botm_ul li:hover {
  background: #0812d8;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
  background: #fff;
}

.dingbu {
  width: 260px;
  height: 300px;
  position: fixed;
  right: 20px;
  bottom: 100px;
}

.dingbu_1 {
  width: 50px;
  height: 300px;
  border-radius: 5px;
  overflow: hidden;
  float: right;
}

.dingbu_img {
  position: relative;
}

.dingbu_img_1 {
  position: absolute;
  top: -70px;
}

.dingbu_img_2 {
  position: absolute;
  top: -10px;
}

.dingbu_img_3 {
  position: absolute;
  top: 50px;
}

.dingbu_img_4 {
  position: absolute;
  top: 230px;
}

.dingbu_1 li {
  padding: 10px;
  border-bottom: 1px solid #e5e8ed;
  font-size: 14px;
  text-align: center;
  background: #fff;
}

.dingbu_1 li a {
  width: 38px;
  height: 19px;
  color: #666666;
}

.dingbu_2 {
  height: 60px;
  margin-top: 10px;
  border-radius: 5px;
}

.dingbu_2 p {
  font-size: 14px;
  color: #007bff;
  line-height: 10px;
}

.dingbu_img {
  float: left;
}

.dingbu_1 li:hover {
  background: #007bff;
}

.dingbu_1 li:hover a,
.dingbu_1 li:hover p {
  color: #fff;
}

.top_show {
  width: 100%;
  height: 280px;
  background: #fff;
  position: absolute;
  top: 164px;
  left: 0;
  position: fixed;
}

.kong {
  width: 100%;
  height: 184px;
}

.bread {
  width: 100%;
  height: 48px;
  background: #fff;
}

.bread_1 {
  width: 1200px;
  height: 48px;
  margin: 0 auto;
  line-height: 48px;
}

.content {
  width: 100%;
}

.content_1 {
  width: 1200px;
  margin: 0 auto;
}

.content_2 {
  width: 100%;
  height: auto;
  background: #fff;
  margin: 20px 0;
}

.content_2top {
  width: 100%;
  height: 61px;
  /* max-width: 1200px;; */
}

.content_2top_ul {
  width: 1160px;
  height: 61px;
  margin: 0 auto;
  border-bottom: 1px solid #e4e4e4;
  display: flex;
}

.content_2top_p {
  line-height: 61px;
  color: #999999;
  font-size: 14px;
}

.content_2top_ul li {
  /* height: 30px; */
  /* float: left; */
  font-size: 14px;
  padding: 16px 0 16px 39px;
  /* margin: 16px 0 16px 39px; */
  border-radius: 5px;
  line-height: 30px;
  color: #222222;
}

.content_2top_ul li a {
  font-size: 14px;
  padding: 10px;
  border-radius: 5px;
  line-height: 30px;
  color: #222222;
}

.content_2top_ul li:hover a {
  background: #007bff;
  color: #fff;
}

.content_two {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}

.content_two ul {
  width: 100%;
  height: auto;
}

.content_two li {
  width: 270px;
  height: 361px;
  border: 1px solid #e4e4e4;
  margin: 20px 4px 5px 20px;
  float: left;
}

.content_two_p2 a {
  color: #222222;
}

.content_two li:hover {
  border: 1px solid #007bff;
}

.content_two li:hover .content_two_p2 {
  color: #007bff;
}

.content_two li:hover .content_two_p2 a {
  color: #007bff;
}

.imgg {
  width: 100%;
  height: 220px;
}

.imgg img {
  width: 100%;
  height: 220px;
}

.content_two p {
  margin: 10px 0 0 20px;
}

.content_two_p2 {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #222222;
}

.content_three {
  width: 100%;
}

.content_three_1 {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}

.fenye {
  text-align: center;
  margin: 39px 0 0 0;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.top_cent_p {
  font-size: 14px;
  color: #007bff;
  line-height: 40px;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  float: right;
  display: flex;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}

.top_ul li:nth-child(2) {
  margin: 0 20px;
}

.top_ul li:nth-child(3) {
  margin: 0;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.floor_china_1 li a {
  color: #85919a;
  font-size: 14px;
}
.top_show {
  width: 100%;
  height: 280px;
  background: #fff;
  position: absolute;
  top: 184px;
  left: 0;
  position: fixed;
  display: none;
}

.hover_li:hover .top_show {
  display: block;
}

.top_show_1 {
  width: 700px;
  height: 164px;
  margin: 34px auto;
}

.top_show_1 li {
  width: 220px;
  height: 72px;
  float: left;
  margin: 10px 0 0 10px;
  border-radius: 4px;
  line-height: 25px;
  overflow: hidden;
}

.top_show_1 li:hover {
  background: #f4f5f9ff;
}

.top_show_1 li p a {
  /* padding: 5px 5px 0 5px; */
  font-size: 14px;
  color: #999999ff;
  text-align: left;
}

.top_show_1 li p:first-child {
  border-left: 5px solid #007bff;
  border-radius: 0;
  margin: 10px 0 10px 0;
}

.top_show_1 li p:first-child a {
  width: auto;
  height: 19px;
  font-size: 18px;
  color: #222222ff;
  margin: 10px 0 10px 0;
  text-align: left;
}

.dingbu_1 li:hover .img_block {
  display: none;
}

.img_none {
  display: none;
}

.dingbu_1 li:hover .img_none {
  display: block;
}

.ol_li img {
  width: 25px;
  height: 25px;
  margin: 10px 0 0 3px;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.aa {
  color: #222222ff;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -10px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Fuwu/Fuwu.vue